import { ControlValueAccessor, FormControlDirective, FormControl, ControlContainer } from '@angular/forms';
import { ViewChild, Input, Component } from '@angular/core';
import { isEqual } from 'lodash';

@Component({
    selector: 'app-base-accessor-control',
    template: ''
})
export class BaseAccessorControlComponent implements ControlValueAccessor {

    @ViewChild(FormControlDirective, { static: true })
    formControlDirective: FormControlDirective;

    @Input()
    formControl: FormControl;

    @Input()
    formControlName: string;

    get control() {
        return this.formControl || this.controlContainer.control.get(this.formControlName);
    }

    constructor(private controlContainer: ControlContainer) {
    }

    registerOnTouched(fn: any): void {
        this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }

    registerOnChange(fn: any): void {
        this.formControlDirective.valueAccessor.registerOnChange(fn);
    }

    writeValue(value: any): void {
        this.formControlDirective.valueAccessor.writeValue(value);
    }

    setDisabledState(isDisabled: boolean): void {
        this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
    }
}

@Component({
    selector: 'app-abstract-input-control',
    template: ''
})
export abstract class AbstractInputControlComponent<T> implements ControlValueAccessor {

    @Input()
    get value(): T {
      return this._value;
    }
    set value(value: T) {
      if (!isEqual(this._value, value)) {
        this._value = value;
        this.setFormValues(value);
        this.onChange(value);
      }    
    }

    @Input()
    disabled: boolean;

    private _value: T;

    constructor() {}

    onChange(value: T) { }

    onTouched() { }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    registerOnChange(fn: (value: T) => void): void {
        this.onChange = fn;
    }

    writeValue(value: T): void {
        this.value = value;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    abstract setFormValues(value: T): void;
}

